import Vue from 'vue'
import Vuex from 'vuex'

import academy from './modules/academy'
import assets from './modules/assets'
import auth from './modules/auth'
import billing from './modules/billing'
import editor from './modules/editor'
import exit from './modules/exit'
import products from './modules/products'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    academy,
    assets,
    auth,
    billing,
    editor,
    exit,
    products
  }
})
